import { css } from '@emotion/core';
import MediaQueries from '../../../../../styles/Grid/MediaQueries';

export const rowCss = css({
  marginTop: 15,
  [MediaQueries.md]: {
    marginTop: 48,
  },
});

export const rightImageColumns = css({
  minHeight: 205,
  position: 'relative',
  [MediaQueries.md]: {
    minHeight: 330,
  },
});

export const leftImageColumns = css({
  maxHeight: 25,
  position: 'relative',
  [MediaQueries.md]: {
    maxHeight: 39,
  },
});

export const rightImageContainer = css({
  top: 0,
  position: 'absolute',
  left: 0,
  minHeight: 152,
  width: '100%',
  [MediaQueries.md]: {
    minHeight: 238,
  },
});

export const leftImageContainer = css({
  top: 0,
  left: 0,
  minHeight: 147,
  width: '100%',
  [MediaQueries.md]: {
    minHeight: 225,
  },
});

export const relativeElement = css({
  position: 'relative',
});
